export const blockIconsSocialSupportAgentNew = (
	<span className='material-symbols-outlined'>support_agent</span>
);
